import variables from './cssInJs/variables';

const cssEmotion = {
  breakpointNames: variables.breakpointNames,
  breakpoints: variables.breakpoints
}

const firebaseSettings = {
  apiKey: "AIzaSyBG3QvbQIKcdg1nSuTFypu759gzDT0ENIE",
  authDomain: "abna-39c97.firebaseapp.com",
  projectId: "abna-39c97",
  storageBucket: "abna-39c97.firebasestorage.app",
  messagingSenderId: "169461867950",
  appId: "1:169461867950:web:52c3aa1c69c62da2ca143f",
  measurementId: "G-F816HEQPR3"
}

const apiNetJwt = async (options) => {
  // Lazy import to avoid circular dependency
  const { getIdToken } = await import('./auth/services/authHelper');
  const token = await getIdToken();
  //console.log(token)
  if (token) {
    options.headers = options.headers || {}
    options.headers['Authorization'] = `Bearer ${token}`
  }
}

export default {
  cssEmotion,
  firebaseSettings,
  apiNetJwt
}